<div modalHeader class="modal-header">
  <h2>Invite user</h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn pt-1" (click)="close()"></tr-icon>
</div>

<div modalContent class="modal-body" *ngIf="form">
  <p>Select an existing user or invite a new one by entering their information. Both fields are required.</p>

  <form [formGroup]="form">
    <div class="form-group">
      <label class="control-label">User email*</label>
      <div class="d-flex flex-row">
        <div class="input-group">
          <input
            class="form-control no-round-right h-100"
            formControlName="email"
            placeholder="Enter email"
            [disabled]="readonly"
            [ngbTypeahead]="searchByEmail"
            (selectItem)="userSelected($event, undefined)"
          >
          <button class="btn btn-icon btn-light no-round-left" (click)="reset()">
            <tr-icon [icon]="icon.cancel"></tr-icon>
          </button>
        </div>
      </div>
      <control-messages [control]="emailControl"></control-messages>
    </div>

    <div class="form-group">
      <label class="control-label">User full name*</label>
      <div class="d-flex flex-row">
        <div class="input-group">
          <input
            class="form-control no-round-right h-100"
            placeholder="Enter name"
            formControlName="name"
            [disabled]="readonly"
            [ngbTypeahead]="searchByName"
            (selectItem)="userSelected(undefined, $event)"
          >
          <button class="btn btn-icon btn-light no-round-left" (click)="reset()">
            <tr-icon [icon]="icon.cancel"></tr-icon>
          </button>
        </div>
      </div>
      <control-messages [control]="nameControl"></control-messages>
    </div>

    <div class="form-group">
      <label class="control-label">Role</label>
      <span class="bi bi-info-circle-fill info-badge ml-1" data-toggle="tooltip" data-placement="top" title="Managers can access location preferences. Users have no access to settings."></span>
      <tablesready-btn-group-control
        bindName="name"
        bindValue="value"
        [items]="userRoles"
        [control]="roleControl"
        [buttonType]="buttonsColor.success"
      ></tablesready-btn-group-control>
    </div>
  </form>
</div>

<div modalFooter class="d-flex pt-3">
  <div class="form-group col">
    <button
      class="btn btn-info w-100"
      [disabled]="inProgress"
      (click)="send()"
    >Send invite</button>
  </div>

  <div class="form-group col">
    <button class="btn btn-danger w-100" (click)="close()" [disabled]="inProgress">Cancel</button>
  </div>
</div>
